import { ColumnViewModel } from '../../shared/column-types';

export const VARIANTS_ALL: ColumnViewModel = {
  columns: [
    'strID',
    'geneSymbol',
    'polyphen_score',
    'sift_score',
    'numDiseasesAssociatedToVariant',
    'numChemicals',
    'DSI',
    'DPI',
    'chromosome',
    'coord',
    'DBSNPclass',
    'mostSevereConsequences',
    'alleles',
    'exome',
    'genome',
    'numPublications',
    'numberPmidsWithChemsIncludedInEvidence',
    'firstRef',
    'lastRef',
    'gene_ncbi_id',
    'gene_ensembl_id',
  ],
  defaultVisible: [
    'strID',
    'geneSymbol',
    'numDiseasesAssociatedToVariant',
    'DSI',
    'DPI',
    'mostSevereConsequences',
    'alleles',
    'exome',
    'numPublications',
    'firstRef',
    'lastRef',
  ],
};